import ToastMaker from "../../components/UI/NotificationToast";

const Toast = ToastMaker();

export default Toast;
